import { InboxKindSuggestions } from './inbox-kind-suggestions.tsx';

export function InboxInstructionActionSuggestions({ conversationId }: { conversationId: string }) {
  return <InboxKindSuggestions conversationId={conversationId} kind="visit_instruction" />;
}
